import { Spinner } from '@lean-agility/design-system/react';

export function LoadingPage() {
  return (
    <div className="flex items-center justify-center py-16">
      <Spinner size="lg" />
    </div>
  );
}
